













import { Component, Mixins } from 'vue-property-decorator';
import { ProfileFilter } from 'client-website-ts-library/filters';
import { Profile, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { View } from 'client-website-ts-library/plugins';

import { Context, ContextItemType } from 'client-website-ts-library/types/Context';
import Form from '@/components/Forms/Form.vue';
import VideoBanner from '@/components/VideoBanner.vue';
import Panels from '@/components/Panels.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Loader from '../components/UI/Loader.vue';

@Component({
  components: {
    ProfileCards,
    Loader,
    Panels,
    VideoBanner,
    Form,
  },
})
export default class OverwhelmingOffer extends Mixins(View) {
  private formCtx: Context | null = null;

  mounted() {
    this.formCtx = {
      ClientWebsiteId: Config.Website.Id,
      Items: [
        {
          Type: ContextItemType.EnquiryTargetProfile,
          Id: 'dd5af4eb-1424-4dbd-be9b-60c8e577a560',
        },
      ],
    };
  }
}
